import React, { useState } from 'react';
import '../../../src/assets/css/HiTech/locations.css';
import LocationsSection from '../Common/LocationsSection';
import StatsCounter from '../Common/StatsCounter';

const Locations = () => {

  return (
    <div classNameName="service">

<div className="container-fluid page-header py-5">
            <div className="container text-center py-5">
                <h1 className="display-2 text-white mb-4 animated slideInDown">Locations</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol className="breadcrumb justify-content-center mb-0">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Pages</a></li>
                        <li className="breadcrumb-item" aria-current="page">Locations</li>
                    </ol>
                </nav>
            </div>
        </div>

        <StatsCounter />
        <LocationsSection />
</div>
   
  );
};

export default Locations;